import { PlanningDataUtils } from "./PA.TPM.Core/PlanningDataUtils";
import { PlanService } from "./PA.TPM.Services/PlanService";
import { PlanningService } from "./PA.TPM.Services/PlanningService";
import { PAExport } from "./PA.Export.Core/PAExport";
import { DetailAttributes } from "./PA.Metric.Services/PA.Metrics.IF";
import { MetricParameters, MetricsParameterSet } from "./PA.Metric.Services/PAMetrics";
import { PAFile } from "./PA.File.Core/PAFile";
import { ConsumptionAdjustmentsFactory } from "./PA.Consumption.Core/ConsumptionAdjustmentsFactory";
import { UserSecurityService } from "./PA.Security.Services/UserSecurityService";
import { AuditService } from "./PA.Core/Security/AuditService";
import { AuditLogType } from "./PA.Core/PA.Core.IF.Audit";
import { ConditionCollection } from "./PA.MD.Services/ConditionCollection";
import { ConsumerProductService } from "./PA.MD.Services/ConsumerProductService";
import { PeriodService } from "./PA.MD.Services/PeriodService";
import { ControlPointService } from "./PA.MD.Services/ControlPointService";
import { CustomerHierarchy } from "./PA.MD.Services/CustomerHierarchy";
import { ProductHierarchy } from "./PA.MD.Services/ProductHierarchy";
import { PeriodHierarchy } from "./PA.MD.Services/PeriodHierarchy";
import { PeriodHierarchyService } from "./PA.MD.Services/PeriodHierarchyService";
import { ProductHierarchyService } from "./PA.MD.Services/ProductHierarchyService";
import { FilteredHierarchy } from "./PA.MD.Services/FilteredHierarchy";
import { EntityManager } from "./PA.MD.Core/EntityManager";
import { EntityTypeUtils } from "./PA.MD.Entity/EntityTypeUtils";
import { MDUsageService } from "./PA.MD.Services/MDUsageService";
import { LoaderStatus } from "./PA.Loader.Core/PA.Loader.IF.Aspects";
import { Loader } from "./PA.Loader.Services/Loader";
import { HierarchyService } from "./PA.MD.Hierarchy/HierarchyService";
import { HierarchyProcessingStatus } from "./PA.MD.Core/PA.MD.IF.Hierarchy";
import { HierarchyStructureManager } from "./PA.MD.Hierarchy/HierarchyStructureManager";
import { HierarchyStructureNavigator } from "./PA.MD.Hierarchy/HierarchyStructureNavigator";
import { BusinessPolicyService } from "./PA.MD.BusinessPolicy/BusinessPolicyService";
import { BusinessPolicyProcessingStatus } from "./PA.MD.Core/PA.MD.IF.BusinessPolicy";
import { CubeSourceMetaDataService } from "./PA.HyperRectangle.Services/CubeSourceMetaDataService";
import { CubeSourceUtils } from "./PA.HyperRectangle.Core/CubeSourceUtils";
import { ModelUtils } from "./PA.Model.Services/ModelUtils";
import { ModelingSessionStatus } from "./PA.Model.Services/ModelingSessionServices.IF";
import { ModelingSessionService } from "./PA.Model.Services/ModelingSessionService";
import { SettlementMetricsService } from "./PA.Settlements.Services/SettlementMetricsService";
import { PALockClient } from "./PA.Concurrency.Services/PALockClient";
import { PALockAdminClient } from "./PA.Concurrency.Services/PALockAdminClient";
import { UIClipboardService, UIFrameworkService } from "./PA.UIFramework.Services/UIFrameworkService";
import { DimensionDataService } from "./PA.Reporting.Services/DimensionDataService";
import { PAReportTokenService } from "./PA.Reporting.Services/PATableauTokenService";
import { PATagDataService } from "./PA.Reporting.Services/PATagDataService";
import { ModelingScorecardService } from "./PA.Model.Services/ModelingScorecardService";
import { JobParamManager } from "./PA.Job.Core/JobParamManager";
import { SnapshotService } from "./PA.Snapshot.Services/SnapshotService";
import { FileLoaderDataIntegrationService } from "./PA.FileLoader.Services/FileLoaderDataIntegrationService";
import { HierarchyUsage } from "./PA.MD.Hierarchy/HierarchyUsage";
import { SimulationCollectionCubeSource } from "./PA.Simulation.BusinessObjects/SimulationCollectionCubeSource";
import { SimulationCollection } from "./PA.Simulation.BusinessObjects/SimulationCollection";
import { SpendFunctionUtils } from "./PA.Simulation.Services/SpendFunctionUtils";
import { MetricDataSetProvider } from "./PA.MetricDataSet.Core/MetricDataSetProvider";
import { MetricDataSet } from "./PA.MetricDataSet.Core/MetricDataSet";
import { DBMetricDataSetProvider } from "./PA.MetricDataSet.Core/DBMetricDataSetProvider";
import { DataSetUtils } from "./PA.MetricDataSet.Core/DataSetUtils";
import { ComputedAttribute } from "./PA.MetricDataSet.Core/ComputedAttribute";
import { ComputedMetric } from "./PA.MetricDataSet.Core/ComputedMetric";
import { HighChartsMetaDataUtils } from "./PA.UIM.MetricDataSet/HighChartsMetaDataUtils";
import { DataMartUtils } from "./PA.Reporting.Services/DataMartUtils"
import { VolumeAlignmentUtils } from "./PA.TPM.Services/VolumeAlignmentUtils"
import * as TPMConstants from "./PA.TPM.Core/TPM.Constants"
import { CalendarUtils } from "./PA.MD.Services/CalendarUtils"
import { MetricDataSetUnion } from "./PA.MetricDataSet.Core/MetricDataSetUnion"
import { SimulationService } from "./PA.Simulation.Services/SimulationService";
import { PeriodMetricContextDataProvider } from './PA.MetricDataSet.Core/PeriodMetricContextDataProvider'
import { HierarchyPathDataProvider } from './PA.MetricDataSet.Core/HierarchyPathDataProvider'
import { ScenarioPlannerService } from "./PA.Simulation.Services/ScenarioPlannerService";
import {
    ScenarioPlannerCalcStatus,
    isAScenarioPlannerAlgorithm
} from "./PA.Simulation.Services/ScenarioPlannerService.IF";
import { GanttLayoutMetaDataUtils } from './PA.UIM.MetricDataSet/GanttLayoutMetaDataUtils'
import { FacilitatedCleansingService } from './PA.FC.Services/FacilitatedCleansingService'
import { SimulationConversionUtils } from "./PA.Simulation.Services/SimulationConversionUtils";
import { FlowEditorUtils } from "./PA.Automation.Core/FlowEditorUtils";
import { CubeSourceDataProvider } from "./PA.MetricDataSet.Core/CubeSourceDataProvider";
import { HierarchyStructureClient } from './PA.MD.Hierarchy/HierarchyStructureClient'
import { LabelTextService } from "./PA.Core/Language/LabelTextService";

const MdlServices = {
    Services: {
        TPM: {
            PlanningDataUtils: PlanningDataUtils,
            PlanService: PlanService,
            PlanningService: PlanningService,
            SnapshotService: SnapshotService,
            VolumeAlignmentUtils: VolumeAlignmentUtils,
            FacilitatedCleansingService: FacilitatedCleansingService,
            Constants: TPMConstants
        },
        Export: {
            Export: PAExport
        },
        Metric: {
            DetailAttributes: DetailAttributes,
            MetricParameters: MetricParameters,
            MetricParameterSet: MetricsParameterSet
        },
        File: {
            File: PAFile
        },
        Automation: {
            FlowEditorUtils: FlowEditorUtils
        },
        FileLoader: {
            FileLoaderDataIntegration: FileLoaderDataIntegrationService
        },
        Consumption: {
            AdjustmentFactory: ConsumptionAdjustmentsFactory
        },
        Security: {
            UserSecurityService: UserSecurityService,
            AuditService: AuditService,
            AuditLogType: AuditLogType
        },
        MD: {
            CalendarUtils: CalendarUtils,
            ConditionCollection: ConditionCollection,
            ConsumerProductService: ConsumerProductService,
            PeriodService: PeriodService,
            ControlPointService: ControlPointService,
            CustomerHierarchy: CustomerHierarchy,
            ProductHierarchy: ProductHierarchy,
            PeriodHierarchy: PeriodHierarchy,
            PeriodHierarchyService: PeriodHierarchyService,
            ProductHierarchyService: ProductHierarchyService,
            FilteredHierarchy: FilteredHierarchy,
            EntityManager: EntityManager,
            EntityTypeUtils: EntityTypeUtils,
            MDUsageService: MDUsageService,
            JobParamManager: JobParamManager
        },
        Loader: {
            LoaderStatus: LoaderStatus,
            Loader: Loader
        },
        Hierarchy: {
            HierarchyService: HierarchyService,
            HierarchyUsage: HierarchyUsage,
            HierarchyProcessingStatus: HierarchyProcessingStatus,
            HierarchyStructureClient: HierarchyStructureClient,
            HierarchyStructureManager: HierarchyStructureManager,
            HierarchyStructureNavigator: HierarchyStructureNavigator
        },
        BusinessPolicy: {
            BusinessPolicyService: BusinessPolicyService,
            BusinessPolicyProcessingStatus: BusinessPolicyProcessingStatus
        },
        Simulation: {
            SimulationCollection: SimulationCollection,
            SimulationCollectionCubeSource: SimulationCollectionCubeSource,
            SpendFunctionUtils: SpendFunctionUtils,
            SimulationService: SimulationService,
            ScenarioPlannerService: ScenarioPlannerService,
            ScenarioPlannerCalcStatus: ScenarioPlannerCalcStatus,
            isAScenarioPlannerAlgorithm: isAScenarioPlannerAlgorithm,
            SimulationConversionUtils: SimulationConversionUtils
        },
        HyperRectangle: {
            CubeSourceMetaDataService: CubeSourceMetaDataService,
            CubeSourceUtils: CubeSourceUtils
        },
        Visualization: {
            MetricDataSetProvider: MetricDataSetProvider,
            DBMetricDataSetProvider: DBMetricDataSetProvider,
            PeriodMetricContextDataProvider: PeriodMetricContextDataProvider,
            HierarchyPathDataProvider: HierarchyPathDataProvider,
            MetricDataSet: MetricDataSet,
            MetricDataSetUnion: MetricDataSetUnion,
            DataSetUtils: DataSetUtils,
            HighChartsMetaDataUtils: HighChartsMetaDataUtils,
            GanttLayoutMetaDataUtils: GanttLayoutMetaDataUtils, //gantt layout service
            ComputedAttribute: ComputedAttribute,
            ComputedMetric: ComputedMetric,
            CubeSourceDataProvider: CubeSourceDataProvider
        },
        Model: {
            ModelUtils: ModelUtils,
            ModelingSessionStatus: ModelingSessionStatus,
            ModelingSessionService: ModelingSessionService,
            ModelingScorecardService: ModelingScorecardService
        },
        Settlement: {
            SettlementMetricsService: SettlementMetricsService
        },
        Concurrency: {
            PALockClient: PALockClient,
            PALockAdminClient: PALockAdminClient
        },
        UIFramework: {
            UIFrameworkService: UIFrameworkService,
            UIClipboardService: UIClipboardService
        },
        Reporting: {
            DimensionDataService: DimensionDataService,
            PAReportTokenService: PAReportTokenService,
            PATagDataService: PATagDataService,
            DataMartUtils: DataMartUtils
        },
        Language: {
            LabelTextService: LabelTextService
        }
    }
}

export { MdlServices };
